import dayjs from 'dayjs'
import { INACTIVITY_TIMEOUT_IN_SECONDS } from 'consts'

export const doesUserInteracted = state => {
  const lastUserInteraction = state.app.lastUserInteraction
  return (
    lastUserInteraction &&
    lastUserInteraction.diff(dayjs(), 'minute') <
      INACTIVITY_TIMEOUT_IN_SECONDS / 60
  )
}

export const isWarningModalOpened = state => state.app.shouldShowTimeoutModal

export const calculateTimeUntilAutoRefresh = expiryTime => {
  const currentTime = Date.now() / 1000
  const timeUntilExpire = expiryTime - currentTime
  const timeUntilAutoRefresh = timeUntilExpire - 1 * 60 // 1 minute before token expires
  return timeUntilAutoRefresh
}
